export default __webpack_public_path__ + "static/media/knight-ventures-preview.b2048eb8.png";